import React from "react";
import * as S from "./styles";

const ReceiveDate = () => {
  return (
    <S.Container>
      <S.Span>
        Receba até
        <S.Strong>01 de Dezembro</S.Strong>
      </S.Span>

      <S.Value>Grátis</S.Value>
    </S.Container>
  );
};

export default ReceiveDate;
